export default __webpack_public_path__ + "6375e8391ea7b5379f25f07720c2d2d3.png";